// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Ty0tZpsZe3AoGQ_gmQ86","box":"E17i_qonAWGqyQaHZLAg","cardTitle":"MAZE9bjZZCotoWVy0eyV"};